import { render } from "./impressoras-list.vue?vue&type=template&id=0a6a51b2"
import script from "./impressoras-list.vue?vue&type=script&lang=js"
export * from "./impressoras-list.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__